






















import { Component, Vue } from "vue-property-decorator";

import LayoutReportStep from "@/layouts/LayoutReportStep.vue";

import { ReportModule } from "@/store/modules/report.store";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportDescription extends Vue implements IReportStep {
  public header: IReportHeaderData = {
    title: "report.formDescription.title",
    description: "report.formDescription.description"
  };

  counter = 1000;
  placeholder = "report.formDescription.placeholder";

  internalMessage = "";

  get isDone() {
    return true;
  }

  get message(): string {
    return ReportModule.inCreationReport.message;
  }

  set message(m: string) {
    this.internalMessage = m;
  }

  updateMessage(e: any) {
    ReportModule.setMessage(e.target.value);
  }
}
